import React from 'react';
import { searchFieldWidth, searchFormString, searchLabelStyle } from 'src/components/common/common';

interface RadioButtonFormProps {
	title: string;
	titleValueMap?: { title: string, value: string }[];
    value : string;
	titleless?: boolean;
	className?: string;
	name: string;
	editable?: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchRadioButtonForm: React.FC<RadioButtonFormProps> = (props: RadioButtonFormProps) => {

	const { 
		title,
		titleValueMap,
        value,
		titleless = false,
		className = "",
		name,
		editable = true,
		onChange,
	} = props;   

	return (
		<div className={`flex h-[20px] ${ searchFormString } ${ className } ${ searchFieldWidth } `}>
			<p className={`${ searchLabelStyle } cursor-pointer mr-[5px] ${titleless ? 'hidden' : ''}`} 
				tabIndex={editable ? 0 : -1}
			>
				{title}
			</p>
			{titleValueMap && titleValueMap.map((mapItem) => (
				<div key={mapItem.value} className={`flex`}>
					<div 
						className={`flex w-[75px] items-center border border-gray-300 rounded-[4px] pl-[5px]
								${editable ? '' : 'bg-gray-100'}
							`}
						onClick={() => {
							if(!editable) return;
							onChange({ target: { name, value: mapItem.value } } as React.ChangeEvent<HTMLInputElement>);
						}}
					>
						<input 
							id={`${name}-${mapItem.value}`}
							type="radio" 
							value={mapItem.value} 
							onChange={onChange} 
							name={name} 
							className=""
							checked={mapItem.value === value}
							disabled={!editable}
						/>
						<label htmlFor={`${name}-${mapItem.value}`} className="pl-[5px] cursor-pointer">{mapItem.title}</label>
					</div>
				</div>
			))}
		</div>
	)
}